import { render, staticRenderFns } from "./PostListing.vue?vue&type=template&id=3294956a&scoped=true&"
import script from "./PostListing.vue?vue&type=script&lang=ts&"
export * from "./PostListing.vue?vue&type=script&lang=ts&"
import style0 from "./PostListing.vue?vue&type=style&index=0&id=3294956a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3294956a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VChipGroup,VDialog,VImg})
